import { initStore } from '../../../common';
import { historyListMap } from '../../../view/pages/PlayerDetails/components/Wallet/Wallet.const';
import { actions } from './actions';

export const playerDetailsStore = (): void => {
	const initialState = {
		slice: 'PLAYER_DETAILS',
		player: {},
		historyRows: [],
		realBonusHistory: [],
		realBonusHistoryColumns: historyListMap,
		realBonusHistoryRows: [],
		playerLoading: false,
		partners: [],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
